import { Text, VStack } from '@wegroup/design-system';
import React from 'react';

interface Props<T> {
  title: string;
  items: T[];
  keyExtractor: (item: T) => string;
  renderRiskObject: (item: T) => React.ReactElement;
}

function RiskObjectSelectRadioGroup<T>({
  title,
  items,
  renderRiskObject,
  keyExtractor,
}: Props<T>) {
  return (
    <VStack spacing="4" align="stretch">
      <Text textStyle="normalBodyMedium">{title}</Text>
      <VStack spacing="3" direction="row" align="stretch">
        {items.map((item) => (
          <div key={keyExtractor(item)}>{renderRiskObject(item)}</div>
        ))}
      </VStack>
    </VStack>
  );
}

export default RiskObjectSelectRadioGroup;
